module.exports = __webpack_public_path__ + "img/marketing-background-left.29f11e8a.png";